var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _path8, _path9, _defs3, _path10, _defs4, _path11, _defs5, _path12, _defs6, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{clip-path:url(#SVGID_00000139271307758784798310000002865118266178004159_);}\n\t.st3{fill:#E86E7B;}\n\t.st4{clip-path:url(#SVGID_00000036948232957122365240000000452293937885939857_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_00000163055949802278130140000007658213241406926472_);}\n\t.st7{clip-path:url(#SVGID_00000172432748064065217540000002461576087954000559_);}\n\t.st8{clip-path:url(#SVGID_00000039836271135379105470000011697615515403297441_);}\n\t.st9{clip-path:url(#SVGID_00000166662531070975951520000013781894562741762182_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023963559365905944200000008620499397711344567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023963559365905944200000008620499397711344567_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100349453049594177210000015102410184629905343_",
    x: 5,
    y: 8.8,
    width: 82.4,
    height: 82.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007422762017653129930000010575343769998617520_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100349453049594177210000015102410184629905343_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000007422762017653129930000010575343769998617520_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.4,55.2c-0.4-3.7-0.6-7.9-0.6-11.3c0-6.9,0-25.1-12.3-25.1c-14.1,0-22.9,33.3-22.9,50.9 c0,2.7,0,15.8,4.5,19.9c1,1,2.4,1.7,3.7,1.7c3.1,0,4.9-1.4,6.2-2.4c1.7-1.4,4.5-3.5,11-5.1C44.1,79.5,42.4,66.4,41.4,55.2z  M29,78.1c-7.6,2.1-10.6,4.5-12.7,6.2c-1.4,1-1.7,1.4-2.7,1.4c-1.4-1-2.7-9-2.7-16.1c0-19.9,9.6-45.4,17.6-45.4 c4.9,0,6.9,6.2,6.9,19.6c0,4.1,0.4,8.2,1,12C37.3,68.1,37.6,75.7,29,78.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.4,69.5c0-17.6-9-50.9-22.9-50.9c-12.3,0-12.3,18.2-12.3,25.1c0,3.7-0.4,7.6-0.6,11.3 c-1.4,11.3-2.7,24.4,10.6,28.2c6.5,2.1,9,3.7,11,5.1c1.7,1.4,3.5,2.4,6.2,2.4c1.4,0,2.7-0.6,3.7-1.7C87.4,85,87.4,72,87.4,69.5z  M79.1,85.7c-1,0-1.4-0.4-3.1-1.4c-2.1-1.7-5.1-4.1-12.7-6.2c-8.6-2.4-8.2-9.6-6.9-22.3c0.4-4.1,1-7.9,1-12s0-10,1.4-14.1 c1.4-4.9,3.7-5.5,5.5-5.5c7.6,0,17.6,25.4,17.6,45.4C81.9,76.7,80.5,84.6,79.1,85.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.1,42.7c-0.6,0-2.7,0-4.1-4.5c-0.4-1-1.4-1.7-2.4-1.7c-1,0-2.1,0.6-2.4,1.7c-1.7,4.5-3.7,4.5-4.1,4.5 c-1.4,0-2.7,1.4-2.7,2.7c0,1.4,1.4,2.7,2.7,2.7c2.1,0,4.5-0.6,6.9-3.5c2.1,2.7,4.9,3.5,6.9,3.5c1.4,0,2.7-1.4,2.7-2.7 C55.8,43.8,54.5,42.7,53.1,42.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.1,8.8c-1.4,0-2.7,1-2.7,2.7v28.2c0,1.4,1.4,2.7,2.7,2.7c1.4,0,2.7-1.4,2.7-2.7V11.5 C49,10.2,47.6,8.8,46.1,8.8z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000105386110744416390770000011205145885806128057_",
    x: 67.2,
    y: 18.4,
    width: 34.3,
    height: 34.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013173807215808952900000005200724390435981229_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105386110744416390770000011205145885806128057_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013173807215808952900000005200724390435981229_)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.1,34.2H68.6c-0.9,0-1.4,0.5-1.4,1.4c0,0.9,0.5,1.4,1.4,1.4h31.5c0.9,0,1.4-0.5,1.4-1.4 C101.5,34.7,100.9,34.2,100.1,34.2z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031171538765719135700000012025450764428359854_",
    x: 80.7,
    y: 67.1,
    width: 20.8,
    height: 36.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181082711020977291750000001028322927939804305_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031171538765719135700000012025450764428359854_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181082711020977291750000001028322927939804305_)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.6,82.7h-19c-0.5,0-0.9,0.5-0.9,1.4c0,0.9,0.4,1.4,0.9,1.4h19c0.5,0,0.9-0.5,0.9-1.4 C101.5,83.4,101.1,82.7,100.6,82.7z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000088096705210619221930000011461069254850901162_",
    x: 46.1,
    y: -3.1,
    width: 55.4,
    height: 34.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142897692908314616490000010604624991236620432_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088096705210619221930000011461069254850901162_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142897692908314616490000010604624991236620432_)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.2,12.6H48.4c-1.4,0-2.3,0.5-2.3,1.4c0,0.9,0.9,1.4,2.3,1.4h50.8c1.4,0,2.3-0.5,2.3-1.4 C101.5,13.3,100.6,12.6,99.2,12.6z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000141436523120348128840000006514623331330998656_",
    x: 76.6,
    y: 44.8,
    width: 24.9,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066477910099607160440000015361936379311981471_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141436523120348128840000006514623331330998656_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066477910099607160440000015361936379311981471_)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.5,59.4H77.7c-0.6,0-1,0.5-1,1.3s0.4,1.3,1,1.3h22.8c0.6,0,1-0.5,1-1.3 C101.5,59.9,101.1,59.4,100.5,59.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramsWhite);
export default __webpack_public_path__ + "static/media/diagramsWhite.d120276a99575dcba1787ed7442b75e1.svg";
export { ForwardRef as ReactComponent };